<template>
  <ul>
    <li v-for="item in obj" :key="item.title">
      <img src="@/assets/image/solution_td.png" />
      <img src="@/assets/image/solution_jz.svg" class="bg" />
      <h2>{{ item.title }}</h2>
      <p>
        {{ item.description }}
      </p>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    obj: {
      type: Array,
    },
  },
};
</script>

<style lang="less" scoped>
ul {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 40px;

  li {
    text-align: center;
    position: relative;
    border-radius: 10px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
    overflow: hidden;
    transition: all 0.3s;

    img {
      width: 100%;
      opacity: 0;

      &.bg {
        opacity: 1;
        position: absolute;
        left: 0;
        top: 33%;
        transition: all 0.3s;
      }
    }

    h2 {
      position: absolute;
      top: 20%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 18px;
      width: 80%;
      transition: all 0.3s;
      color: var(--themeColor);
    }

    p {
      position: absolute;
      top: 80%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 70%;
      margin: auto;
      transition: all 0.3s;
      opacity: 0;
      color: #fff;
    }

    &:hover {
      background-color: var(--themeColor);

      img.bg {
        top: -5%;
        opacity: 0.1;
      }

      h2 {
        color: #fff;
      }

      p {
        top: 72%;
        opacity: 1;
      }
    }
  }
}

@media (max-width: 900px) {
  ul {
    grid-gap: 20px;
  }
}

@media (max-width: 850px) {
  ul {
    grid-template-columns: repeat(2, 1fr);

    li {
      & {
        background-color: var(--themeColor);

        img.bg {
          top: -5%;
          opacity: 0.1;
        }

        h2 {
          color: #fff;
        }

        p {
          top: 72%;
          opacity: 1;
        }
      }
    }
  }
}

@media (max-width: 550px) {
  ul {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>